// This file is auto-generated by @hey-api/openapi-ts
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { client } from '../client.gen.js';
import { acceptTerms, adminAddInvestorCredits, adminAddStartupCredits, adminDeleteEvaluation, adminDeletePitchSession, adminDeletePrescreen, adminDeleteUser, adminGetAutomatedEmailById, adminGetDataRoomAnalytics, adminGetDataRoomById, adminGetEligibleStartups, adminGetEvaluationById, adminGetInvestorById, adminGetInvestorPersona, adminGetOnboardingById, adminGetPrescreenById, adminGetPrescreenDocuments, adminGetStartupById, adminGetStartupDocuments, adminGetUserById, adminGetUserDeletionPreview, adminListAutomatedEmails, adminListDataRooms, adminListEvaluations, adminListFeedback, adminListInvestorCredits, adminListInvestors, adminListOnboarding, adminListPrescreens, adminListStartupCredits, adminListStartups, adminListUsers, adminRegenerateEvaluation, adminRerunPrescreen, adminTriggerPersonaResearch, adminTriggerPrescreen, completeImageUpload, completeOnboarding, connectWithStartup, createDocument, createFeedback, createImageUpload, createInvestor, createPitch, createStartup, createStartupDataRoom, createStartupMember, deleteDocument, deleteStartupMember, emailSignInForDataRoom, finishPitch, getDataRoomAnalytics, getDataRoomContent, getDataRoomDocumentDownload, getDataRoomVideoUrl, getDocument, getDocumentDownloadUrl, getHealth, getHealthReady, getInvestor, getInvestorById, getInvestorConfig, getInvestorCreditBalance, getInvestorPitchDeckDownload, getInvestorPitchDetail, getInvestorPitchDocumentDownload, getInvestorPitchVideoUrl, getMe, getOnboardingStatus, getPitch, getPitchDeckDownload, getPitchVideoUrl, getPublicInvestorBySlug, getStartup, getStartupConfig, getStartupCreditBalance, getStartupDataRoom, getUserById, investorConnectWithStartup, linkFounderResume, linkStartupDocument, listInvestorCredits, listPitches, listStartupCredits, listStartupDocuments, listStartupMembers, processLinkedIn, processPitchDeck, processWebsite, recordDataRoomHeartbeats, recordDataRoomView, requestInvestorEvaluation, revokeStartupDataRoom, setOnboardingRole, startPitch, unlinkFounderResume, unlinkStartupDocument, updateInvestor, updateMe, updatePitch, updateStartup, updateStartupDocument, updateStartupMember, updateUserLinkedInData, v2AcceptInvite, v2AdminAddInvestorCredits, v2AdminAddStartupCredits, v2AdminAddStartupPurchase, v2AdminBackfillTeamMemberLinkedIn, v2AdminCreateBlogPost, v2AdminDeleteBlogPost, v2AdminDeleteEvaluation, v2AdminDeletePitchSession, v2AdminDeletePrescreen, v2AdminDeleteUser, v2AdminGetAutomatedEmailById, v2AdminGetBlogPost, v2AdminGetDataRoomAnalytics, v2AdminGetDataRoomById, v2AdminGetEvaluationDetails, v2AdminGetEvaluationView, v2AdminGetInvestorById, v2AdminGetInvestorMemberships, v2AdminGetInvestorPersona, v2AdminGetJudgeProfile, v2AdminGetStartupById, v2AdminGetStartupDocuments, v2AdminGetStartupMatchesRefreshStatus, v2AdminGetStartupMemberships, v2AdminGetStartupSubscription, v2AdminGetStartupTeamMembers, v2AdminGetUserById, v2AdminGetUserDeletionPreview, v2AdminGetUserMemberships, v2AdminListAiInsightReports, v2AdminListAutomatedEmails, v2AdminListBlogPosts, v2AdminListDataRooms, v2AdminListEvaluations, v2AdminListFeedback, v2AdminListInvestorCredits, v2AdminListInvestors, v2AdminListStartupCredits, v2AdminListStartupMatches, v2AdminListStartupReactions, v2AdminListStartups, v2AdminListStartupTextFeedbacks, v2AdminListUsers, v2AdminRefreshStartupMatches, v2AdminRegenerateAiInsightReport, v2AdminRegenerateEvaluation, v2AdminRerunPrescreen, v2AdminTriggerPersonaResearch, v2AdminUpdateBlogPost, v2AdminUpsertStartupSubscription, v2CancelInvestorInvite, v2CancelStartupInvite, v2ContactFounder, v2CreateAnalyticsExclusion, v2CreateFeedback, v2CreateInvestor, v2CreateInvestorInvite, v2CreatePitch, v2CreateShareLink, v2CreateStartup, v2CreateStartupInvite, v2CreateSubscriptionCheckout, v2CreateSubscriptionPortal, v2CreateTeamMember, v2DeleteAnalyticsExclusion, v2DeleteShareLink, v2DeleteTeamMember, v2EvaluateStartup, v2FinishPitch, v2GenerateAnalyticsInsights, v2GetAnalyticsSettings, v2GetInsightsReport, v2GetInvestorCreditBalance, v2GetInvestorEvaluation, v2GetInvestorFeed, v2GetInvestorJudgeProfile, v2GetInvestorPersona, v2GetInvestorProfile, v2GetJudgeProfile, v2GetMe, v2GetMyMemberships, v2GetPitch, v2GetPitchEvaluation, v2GetPitchVideoUrl, v2GetPublicInvestorBySlug, v2GetPublicProfileFull, v2GetPublicProfilePreview, v2GetPublishedBlogPost, v2GetStartupActivity, v2GetStartupAnalytics, v2GetStartupCreditBalance, v2GetStartupFeed, v2GetStartupOverview, v2GetStartupPitch, v2GetStartupProfile, v2GetStartupSettings, v2GetStatementReactions, v2GetSubscriptionStatus, v2GetWebsiteStats, v2InvestorConnectWithStartup, v2ListInvestorCredits, v2ListInvestorEvaluationRequests, v2ListInvestorInvites, v2ListPublishedBlogPosts, v2ListShareLinks, v2ListStartupCredits, v2ListStartupInvites, v2ListStartupMatches, v2ListTeamMembers, v2LookupInvite, v2ProfileHeartbeat, v2ProfileTrackEvent, v2ProfileTrackEventBatch, v2PublicDocumentDownload, v2PublicVideoUrl, v2PurchaseOneOff, v2RecordStartupContactInvestor, v2RefreshTeamMemberLinkedIn, v2RegisterProfileVisitor, v2RemoveStartupMember, v2ReorderTeamMembers, v2RequestInvestorEvaluation, v2RequestStartupMatchEvaluation, v2StartPitch, v2StripeWebhook, v2SubmitStatementReaction, v2SubmitTextFeedback, v2TriggerPrescreen, v2UpdateInvestorProfile, v2UpdateMe, v2UpdatePitch, v2UpdateShareLink, v2UpdateStartupProfile, v2UpdateTeamMember, verifyDocument } from '../sdk.gen.js';
const createQueryKey = (id, options, infinite, tags) => {
    const params = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl };
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const getHealthQueryKey = (options) => createQueryKey('getHealth', options);
/**
 * Check if the service is alive and responding
 */
export const getHealthOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthQueryKey(options)
});
export const getHealthReadyQueryKey = (options) => createQueryKey('getHealthReady', options);
/**
 * Check if the service is ready to accept traffic
 */
export const getHealthReadyOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealthReady({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthReadyQueryKey(options)
});
/**
 * Create document and get presigned upload URL
 */
export const createDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a document
 *
 * Deletes document from storage and database
 */
export const deleteDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getDocumentQueryKey = (options) => createQueryKey('getDocument', options);
/**
 * Get document detail by id
 */
export const getDocumentOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentQueryKey(options)
});
/**
 * Verify uploaded document
 */
export const verifyDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Generate short-lived download URL
 */
export const getDocumentDownloadUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getDocumentDownloadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create presigned URL for image upload
 *
 * @deprecated
 */
export const createImageUploadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Validate uploaded image and get public URL
 *
 * @deprecated
 */
export const completeImageUploadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getOnboardingStatusQueryKey = (options) => createQueryKey('getOnboardingStatus', options);
/**
 * Get onboarding status and current progress data
 *
 * @deprecated
 */
export const getOnboardingStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOnboardingStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOnboardingStatusQueryKey(options)
});
/**
 * Set user role (founder or investor)
 *
 * @deprecated
 */
export const setOnboardingRoleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOnboardingRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Mark onboarding as completed
 *
 * Validates all required fields and marks onboarding as complete. Sets startup status to active if founder. Optionally saves attribution data.
 *
 * @deprecated
 */
export const completeOnboardingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getMeQueryKey = (options) => createQueryKey('getMe', options);
/**
 * Get current user's profile data
 *
 * @deprecated
 */
export const getMeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 *
 * @deprecated
 */
export const updateMeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getUserByIdQueryKey = (options) => createQueryKey('getUserById', options);
/**
 * Get user by ID
 *
 * Get any user profile by ID
 *
 * @deprecated
 */
export const getUserByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserByIdQueryKey(options)
});
/**
 * Store raw LinkedIn profile data for a user
 *
 * Service-only endpoint for storing raw LinkedIn scrape data.
 *
 * @deprecated
 */
export const updateUserLinkedInDataMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserLinkedInData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove founder's resume
 *
 * Unlink the resume from founder profile. Document remains in storage.
 *
 * @deprecated
 */
export const unlinkFounderResumeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await unlinkFounderResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Link founder's resume
 *
 * Link an uploaded document as the founder resume.
 *
 * @deprecated
 */
export const linkFounderResumeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkFounderResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Accept terms and conditions
 *
 * Record user acceptance of the current terms and conditions version.
 *
 * @deprecated
 */
export const acceptTermsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getStartupQueryKey = (options) => createQueryKey('getStartup', options);
/**
 * Get user's startup
 *
 * Get the startup associated with the current founder user
 *
 * @deprecated
 */
export const getStartupOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStartup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStartupQueryKey(options)
});
/**
 * Create startup during onboarding
 *
 * Create a new startup and associate it with the current founder. Creates startup in draft status.
 *
 * @deprecated
 */
export const createStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update startup details
 *
 * Update startup information. Allows partial updates during onboarding or in settings.
 *
 * @deprecated
 */
export const updateStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const listStartupDocumentsQueryKey = (options) => createQueryKey('listStartupDocuments', options);
/**
 * List startup documents
 *
 * Get all documents linked to a startup
 *
 * @deprecated
 */
export const listStartupDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStartupDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStartupDocumentsQueryKey(options)
});
/**
 * Link document to startup
 *
 * Link a document to a startup with an optional label
 *
 * @deprecated
 */
export const linkStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Unlink document from startup
 *
 * Remove the link between a document and a startup (does not delete the document)
 *
 * @deprecated
 */
export const unlinkStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await unlinkStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update document label
 *
 * Update the label of a document linked to a startup
 *
 * @deprecated
 */
export const updateStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const listStartupMembersQueryKey = (options) => createQueryKey('listStartupMembers', options);
/**
 * List startup members
 *
 * Get all team members for a startup
 *
 * @deprecated
 */
export const listStartupMembersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStartupMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStartupMembersQueryKey(options)
});
/**
 * Create startup member
 *
 * Add a new team member to a startup
 *
 * @deprecated
 */
export const createStartupMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStartupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete startup member
 *
 * Remove a team member from a startup
 *
 * @deprecated
 */
export const deleteStartupMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteStartupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update startup member
 *
 * Update a team member of a startup
 *
 * @deprecated
 */
export const updateStartupMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStartupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getStartupCreditBalanceQueryKey = (options) => createQueryKey('getStartupCreditBalance', options);
/**
 * Get startup credit balance
 *
 * Get the current credit balance for a startup. Requires startup membership.
 *
 * @deprecated
 */
export const getStartupCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStartupCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStartupCreditBalanceQueryKey(options)
});
export const listStartupCreditsQueryKey = (options) => createQueryKey('listStartupCredits', options);
/**
 * List startup credit transactions
 *
 * List credit transactions for a startup. Requires startup membership.
 *
 * @deprecated
 */
export const listStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStartupCreditsQueryKey(options)
});
export const getStartupConfigQueryKey = (options) => createQueryKey('getStartupConfig', options);
/**
 * Get startup configuration data
 *
 * Returns categories, product stages, raise stages, and status options for dropdowns
 *
 * @deprecated
 */
export const getStartupConfigOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStartupConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStartupConfigQueryKey(options)
});
export const getInvestorConfigQueryKey = (options) => createQueryKey('getInvestorConfig', options);
/**
 * Get investor configuration data
 *
 * Returns investment areas and regions for investor profile dropdowns
 *
 * @deprecated
 */
export const getInvestorConfigOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestorConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorConfigQueryKey(options)
});
/**
 * Submit user feedback
 *
 * @deprecated
 */
export const createFeedbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Email-only sign-in for data room access
 *
 * Create or find a user by email and establish a session without OTP verification
 *
 * @deprecated
 */
export const emailSignInForDataRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailSignInForDataRoom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getDataRoomContentQueryKey = (options) => createQueryKey('getDataRoomContent', options);
/**
 * Get data room content
 *
 * Get data room content by token (requires authentication)
 *
 * @deprecated
 */
export const getDataRoomContentOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDataRoomContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDataRoomContentQueryKey(options)
});
/**
 * Record data room view
 *
 * Record that the current user viewed a data room
 *
 * @deprecated
 */
export const recordDataRoomViewMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordDataRoomView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get data room document download URL
 *
 * Generate a download URL for a startup document in a data room
 *
 * @deprecated
 */
export const getDataRoomDocumentDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getDataRoomDocumentDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get data room deck download URL
 *
 * Generate a download URL for the pitch deck in a data room
 *
 * @deprecated
 */
export const getPitchDeckDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getPitchDeckDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get data room video URL
 *
 * Generate a presigned URL to stream the pitch recording video in a data room
 *
 * @deprecated
 */
export const getDataRoomVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getDataRoomVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Connect with startup
 *
 * Send a connection request email to all startup members
 *
 * @deprecated
 */
export const connectWithStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectWithStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record data room heartbeats
 *
 * Record batched heartbeat events for engagement tracking
 *
 * @deprecated
 */
export const recordDataRoomHeartbeatsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordDataRoomHeartbeats({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getDataRoomAnalyticsQueryKey = (options) => createQueryKey('getDataRoomAnalytics', options);
/**
 * Get data room analytics
 *
 * Get engagement analytics for a data room (startup owners only)
 *
 * @deprecated
 */
export const getDataRoomAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDataRoomAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDataRoomAnalyticsQueryKey(options)
});
/**
 * Revoke startup data room
 *
 * Revoke an active data room for a startup
 *
 * @deprecated
 */
export const revokeStartupDataRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeStartupDataRoom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getStartupDataRoomQueryKey = (options) => createQueryKey('getStartupDataRoom', options);
/**
 * Get startup data room
 *
 * Get the data room and view analytics for a startup
 *
 * @deprecated
 */
export const getStartupDataRoomOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStartupDataRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStartupDataRoomQueryKey(options)
});
/**
 * Create startup data room
 *
 * Create a data room for a startup
 *
 * @deprecated
 */
export const createStartupDataRoomMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStartupDataRoom({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getPublicInvestorBySlugQueryKey = (options) => createQueryKey('getPublicInvestorBySlug', options);
/**
 * Get public investor profile by slug
 *
 * Returns publicly visible investor information and lead investor for the pitch page
 *
 * @deprecated
 */
export const getPublicInvestorBySlugOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPublicInvestorBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPublicInvestorBySlugQueryKey(options)
});
export const getInvestorQueryKey = (options) => createQueryKey('getInvestor', options);
/**
 * Get user's investor
 *
 * Get the investor associated with the current investor user
 *
 * @deprecated
 */
export const getInvestorOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorQueryKey(options)
});
/**
 * Create investor during onboarding
 *
 * Create a new investor and associate it with the current investor.
 *
 * @deprecated
 */
export const createInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getInvestorByIdQueryKey = (options) => createQueryKey('getInvestorById', options);
/**
 * Get investor by ID
 *
 * Get any investor by ID
 *
 * @deprecated
 */
export const getInvestorByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestorById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorByIdQueryKey(options)
});
/**
 * Update investor details
 *
 * Update investor information including slug, investment focus, and other details.
 *
 * @deprecated
 */
export const updateInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getInvestorCreditBalanceQueryKey = (options) => createQueryKey('getInvestorCreditBalance', options);
/**
 * Get investor credit balance
 *
 * Get the current credit balance for an investor. Requires investor membership.
 *
 * @deprecated
 */
export const getInvestorCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestorCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorCreditBalanceQueryKey(options)
});
export const listInvestorCreditsQueryKey = (options) => createQueryKey('listInvestorCredits', options);
/**
 * List investor credit transactions
 *
 * List credit transactions for an investor. Requires investor membership.
 *
 * @deprecated
 */
export const listInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvestorCreditsQueryKey(options)
});
export const getInvestorPitchDetailQueryKey = (options) => createQueryKey('getInvestorPitchDetail', options);
/**
 * Get pitch detail
 *
 * Get detailed pitch session data including startup info, team members, raises, and documents. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDetailOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestorPitchDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorPitchDetailQueryKey(options)
});
/**
 * Get document download URL
 *
 * Get a presigned download URL for a startup document. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDocumentDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getInvestorPitchDocumentDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get pitch deck download URL
 *
 * Get a presigned download URL for the pitch deck. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchDeckDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getInvestorPitchDeckDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get pitch video URL
 *
 * Get a presigned URL for the pitch recording video. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const getInvestorPitchVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getInvestorPitchVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Connect with startup
 *
 * Send a connection request to the startup team. Only accessible for pitches targeted at this investor.
 *
 * @deprecated
 */
export const investorConnectWithStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await investorConnectWithStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Request personalized evaluation
 *
 * Deprecated. Use v2.requestInvestorEvaluation.
 *
 * @deprecated
 */
export const requestInvestorEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestInvestorEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const listPitchesQueryKey = (options) => createQueryKey('listPitches', options);
/**
 * List pitches
 *
 * List pitches for the current user. Founders see their startup pitches, investors see incoming pitches. Optional startupId query param returns published pitches for that startup.
 *
 * @deprecated
 */
export const listPitchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPitches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPitchesQueryKey(options)
});
/**
 * Create pitch session
 *
 * Create a new pitch session for a startup
 *
 * @deprecated
 */
export const createPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getPitchQueryKey = (options) => createQueryKey('getPitch', options);
/**
 * Get pitch session
 *
 * Get a specific pitch session by ID. Accessible by the startup owner or linked investor.
 *
 * @deprecated
 */
export const getPitchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPitch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPitchQueryKey(options)
});
/**
 * Update pitch session
 *
 * Update pitch session details such as cover image and publish status.
 *
 * @deprecated
 */
export const updatePitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Start pitch session
 *
 * Start the pitch session by creating LiveKit room. Returns session with token and URL. Can only be called when session status is ACTIVE.
 *
 * @deprecated
 */
export const startPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await startPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Finish pitch session
 *
 * Finish the pitch session by marking as completed. Can only be called when session status is IN_PROGRESS.
 *
 * @deprecated
 */
export const finishPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await finishPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get pitch video URL
 *
 * Get a presigned URL to download the pitch session recording. Accessible by the startup owner or linked investor.
 *
 * @deprecated
 */
export const getPitchVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getPitchVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminListStartupsQueryKey = (options) => createQueryKey('adminListStartups', options);
/**
 * List all startups (admin)
 *
 * @deprecated
 */
export const adminListStartupsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListStartups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListStartupsQueryKey(options)
});
const createInfiniteParams = (queryKey, page) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body,
            ...page.body
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query
        };
    }
    return params;
};
export const adminListStartupsInfiniteQueryKey = (options) => createQueryKey('adminListStartups', options, true);
/**
 * List all startups (admin)
 *
 * @deprecated
 */
export const adminListStartupsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListStartups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListStartupsInfiniteQueryKey(options)
});
export const adminGetStartupByIdQueryKey = (options) => createQueryKey('adminGetStartupById', options);
/**
 * Get startup by ID (admin)
 *
 * @deprecated
 */
export const adminGetStartupByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetStartupById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetStartupByIdQueryKey(options)
});
export const adminListUsersQueryKey = (options) => createQueryKey('adminListUsers', options);
/**
 * List all users (admin)
 *
 * @deprecated
 */
export const adminListUsersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersQueryKey(options)
});
export const adminListUsersInfiniteQueryKey = (options) => createQueryKey('adminListUsers', options, true);
/**
 * List all users (admin)
 *
 * @deprecated
 */
export const adminListUsersInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersInfiniteQueryKey(options)
});
/**
 * Delete user and associated data (admin)
 *
 * @deprecated
 */
export const adminDeleteUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminGetUserByIdQueryKey = (options) => createQueryKey('adminGetUserById', options);
/**
 * Get user by ID (admin)
 *
 * @deprecated
 */
export const adminGetUserByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserByIdQueryKey(options)
});
export const adminListInvestorsQueryKey = (options) => createQueryKey('adminListInvestors', options);
/**
 * List all investors (admin)
 *
 * @deprecated
 */
export const adminListInvestorsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListInvestorsQueryKey(options)
});
export const adminListInvestorsInfiniteQueryKey = (options) => createQueryKey('adminListInvestors', options, true);
/**
 * List all investors (admin)
 *
 * @deprecated
 */
export const adminListInvestorsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListInvestors({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListInvestorsInfiniteQueryKey(options)
});
export const adminGetInvestorByIdQueryKey = (options) => createQueryKey('adminGetInvestorById', options);
/**
 * Get investor by ID (admin)
 *
 * @deprecated
 */
export const adminGetInvestorByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetInvestorById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetInvestorByIdQueryKey(options)
});
export const adminGetInvestorPersonaQueryKey = (options) => createQueryKey('adminGetInvestorPersona', options);
/**
 * Get investor persona with metric prompts (admin)
 *
 * @deprecated
 */
export const adminGetInvestorPersonaOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetInvestorPersona({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetInvestorPersonaQueryKey(options)
});
/**
 * Trigger persona research for investor (admin)
 *
 * @deprecated
 */
export const adminTriggerPersonaResearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTriggerPersonaResearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminListEvaluationsQueryKey = (options) => createQueryKey('adminListEvaluations', options);
/**
 * List all evaluations (admin)
 *
 * @deprecated
 */
export const adminListEvaluationsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListEvaluationsQueryKey(options)
});
export const adminListEvaluationsInfiniteQueryKey = (options) => createQueryKey('adminListEvaluations', options, true);
/**
 * List all evaluations (admin)
 *
 * @deprecated
 */
export const adminListEvaluationsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListEvaluations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListEvaluationsInfiniteQueryKey(options)
});
/**
 * Delete a single evaluation (admin)
 */
export const adminDeleteEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminGetEvaluationByIdQueryKey = (options) => createQueryKey('adminGetEvaluationById', options);
/**
 * Get evaluation by ID (admin)
 *
 * @deprecated
 */
export const adminGetEvaluationByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetEvaluationById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetEvaluationByIdQueryKey(options)
});
/**
 * Regenerate evaluation for a pitch session (admin)
 *
 * @deprecated
 */
export const adminRegenerateEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRegenerateEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminListFeedbackQueryKey = (options) => createQueryKey('adminListFeedback', options);
/**
 * List all feedback (admin)
 *
 * @deprecated
 */
export const adminListFeedbackOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListFeedbackQueryKey(options)
});
export const adminListFeedbackInfiniteQueryKey = (options) => createQueryKey('adminListFeedback', options, true);
/**
 * List all feedback (admin)
 *
 * @deprecated
 */
export const adminListFeedbackInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListFeedback({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListFeedbackInfiniteQueryKey(options)
});
export const adminListStartupCreditsQueryKey = (options) => createQueryKey('adminListStartupCredits', options);
/**
 * List startup credit transactions (admin)
 *
 * @deprecated
 */
export const adminListStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListStartupCreditsQueryKey(options)
});
/**
 * Add credits to startup (admin)
 *
 * @deprecated
 */
export const adminAddStartupCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddStartupCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminListInvestorCreditsQueryKey = (options) => createQueryKey('adminListInvestorCredits', options);
/**
 * List investor credit transactions (admin)
 *
 * @deprecated
 */
export const adminListInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListInvestorCreditsQueryKey(options)
});
/**
 * Add credits to investor (admin)
 *
 * @deprecated
 */
export const adminAddInvestorCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddInvestorCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminListPrescreensQueryKey = (options) => createQueryKey('adminListPrescreens', options);
/**
 * List all prescreen requests (admin)
 *
 * @deprecated
 */
export const adminListPrescreensOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListPrescreens({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListPrescreensQueryKey(options)
});
export const adminListPrescreensInfiniteQueryKey = (options) => createQueryKey('adminListPrescreens', options, true);
/**
 * List all prescreen requests (admin)
 *
 * @deprecated
 */
export const adminListPrescreensInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListPrescreens({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListPrescreensInfiniteQueryKey(options)
});
/**
 * Trigger a new prescreen for a startup (admin)
 */
export const adminTriggerPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTriggerPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminGetEligibleStartupsQueryKey = (options) => createQueryKey('adminGetEligibleStartups', options);
/**
 * Get startups with documents but no prescreen (admin)
 */
export const adminGetEligibleStartupsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetEligibleStartups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetEligibleStartupsQueryKey(options)
});
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const adminDeletePrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeletePrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminGetPrescreenByIdQueryKey = (options) => createQueryKey('adminGetPrescreenById', options);
/**
 * Get prescreen by ID (admin)
 *
 * @deprecated
 */
export const adminGetPrescreenByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetPrescreenById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetPrescreenByIdQueryKey(options)
});
export const adminGetPrescreenDocumentsQueryKey = (options) => createQueryKey('adminGetPrescreenDocuments', options);
/**
 * Get documents for a prescreen startup (admin)
 */
export const adminGetPrescreenDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetPrescreenDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetPrescreenDocumentsQueryKey(options)
});
/**
 * Rerun prescreen with a selected document (admin)
 */
export const adminRerunPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRerunPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const adminDeletePitchSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeletePitchSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const adminGetStartupDocumentsQueryKey = (options) => createQueryKey('adminGetStartupDocuments', options);
/**
 * Get documents for a startup (admin)
 */
export const adminGetStartupDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetStartupDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetStartupDocumentsQueryKey(options)
});
export const adminListOnboardingQueryKey = (options) => createQueryKey('adminListOnboarding', options);
/**
 * List all onboarding chat conversations (admin)
 *
 * @deprecated
 */
export const adminListOnboardingOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListOnboarding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListOnboardingQueryKey(options)
});
export const adminListOnboardingInfiniteQueryKey = (options) => createQueryKey('adminListOnboarding', options, true);
/**
 * List all onboarding chat conversations (admin)
 *
 * @deprecated
 */
export const adminListOnboardingInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListOnboarding({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListOnboardingInfiniteQueryKey(options)
});
export const adminGetOnboardingByIdQueryKey = (options) => createQueryKey('adminGetOnboardingById', options);
/**
 * Get onboarding conversation by ID (admin)
 *
 * @deprecated
 */
export const adminGetOnboardingByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetOnboardingById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetOnboardingByIdQueryKey(options)
});
export const adminListDataRoomsQueryKey = (options) => createQueryKey('adminListDataRooms', options);
/**
 * List all data rooms (admin)
 *
 * @deprecated
 */
export const adminListDataRoomsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListDataRooms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListDataRoomsQueryKey(options)
});
export const adminListDataRoomsInfiniteQueryKey = (options) => createQueryKey('adminListDataRooms', options, true);
/**
 * List all data rooms (admin)
 *
 * @deprecated
 */
export const adminListDataRoomsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListDataRooms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListDataRoomsInfiniteQueryKey(options)
});
export const adminGetDataRoomByIdQueryKey = (options) => createQueryKey('adminGetDataRoomById', options);
/**
 * Get data room by ID with content (admin)
 *
 * @deprecated
 */
export const adminGetDataRoomByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetDataRoomById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetDataRoomByIdQueryKey(options)
});
export const adminGetDataRoomAnalyticsQueryKey = (options) => createQueryKey('adminGetDataRoomAnalytics', options);
/**
 * Get data room analytics (admin)
 *
 * @deprecated
 */
export const adminGetDataRoomAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetDataRoomAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetDataRoomAnalyticsQueryKey(options)
});
export const adminGetUserDeletionPreviewQueryKey = (options) => createQueryKey('adminGetUserDeletionPreview', options);
/**
 * Get user deletion preview (admin)
 *
 * @deprecated
 */
export const adminGetUserDeletionPreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserDeletionPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserDeletionPreviewQueryKey(options)
});
export const adminListAutomatedEmailsQueryKey = (options) => createQueryKey('adminListAutomatedEmails', options);
/**
 * List all automated emails (admin)
 *
 * @deprecated
 */
export const adminListAutomatedEmailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListAutomatedEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListAutomatedEmailsQueryKey(options)
});
export const adminListAutomatedEmailsInfiniteQueryKey = (options) => createQueryKey('adminListAutomatedEmails', options, true);
/**
 * List all automated emails (admin)
 *
 * @deprecated
 */
export const adminListAutomatedEmailsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminListAutomatedEmails({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListAutomatedEmailsInfiniteQueryKey(options)
});
export const adminGetAutomatedEmailByIdQueryKey = (options) => createQueryKey('adminGetAutomatedEmailById', options);
/**
 * Get automated email by ID (admin)
 *
 * @deprecated
 */
export const adminGetAutomatedEmailByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetAutomatedEmailById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetAutomatedEmailByIdQueryKey(options)
});
/**
 * Scrape LinkedIn profile data via Apify
 */
export const processLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Extract startup data from a pitch deck PDF
 */
export const processPitchDeckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processPitchDeck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Extract data from a website using AI
 */
export const processWebsiteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processWebsite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create a new startup
 */
export const v2CreateStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOverviewQueryKey = (options) => createQueryKey('v2GetStartupOverview', options);
/**
 * Get startup overview dashboard
 */
export const v2GetStartupOverviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOverviewQueryKey(options)
});
export const v2GetStartupProfileQueryKey = (options) => createQueryKey('v2GetStartupProfile', options);
/**
 * Get startup profile for data room
 */
export const v2GetStartupProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupProfileQueryKey(options)
});
/**
 * Update startup profile
 */
export const v2UpdateStartupProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateStartupProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupPitchQueryKey = (options) => createQueryKey('v2GetStartupPitch', options);
/**
 * Get pitch overview for startup
 */
export const v2GetStartupPitchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupPitch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupPitchQueryKey(options)
});
export const v2GetStartupCreditBalanceQueryKey = (options) => createQueryKey('v2GetStartupCreditBalance', options);
/**
 * Get startup credit balance
 */
export const v2GetStartupCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupCreditBalanceQueryKey(options)
});
export const v2ListStartupCreditsQueryKey = (options) => createQueryKey('v2ListStartupCredits', options);
/**
 * List startup credit transactions
 */
export const v2ListStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupCreditsQueryKey(options)
});
export const v2GetStartupSettingsQueryKey = (options) => createQueryKey('v2GetStartupSettings', options);
/**
 * Get startup settings
 */
export const v2GetStartupSettingsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupSettingsQueryKey(options)
});
export const v2GetAnalyticsSettingsQueryKey = (options) => createQueryKey('v2GetAnalyticsSettings', options);
/**
 * Get analytics settings (exclusions)
 */
export const v2GetAnalyticsSettingsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetAnalyticsSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetAnalyticsSettingsQueryKey(options)
});
/**
 * Add an email or domain to the analytics exclusion list
 */
export const v2CreateAnalyticsExclusionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateAnalyticsExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove an analytics exclusion entry
 */
export const v2DeleteAnalyticsExclusionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteAnalyticsExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupFeedQueryKey = (options) => createQueryKey('v2GetStartupFeed', options);
/**
 * Get startup activity feed
 */
export const v2GetStartupFeedOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupFeedQueryKey(options)
});
export const v2GetPitchEvaluationQueryKey = (options) => createQueryKey('v2GetPitchEvaluation', options);
/**
 * Get full pitch evaluation detail
 */
export const v2GetPitchEvaluationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPitchEvaluation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPitchEvaluationQueryKey(options)
});
export const v2GetJudgeProfileQueryKey = (options) => createQueryKey('v2GetJudgeProfile', options);
/**
 * Get judge profile for a specific evaluation
 */
export const v2GetJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetJudgeProfileQueryKey(options)
});
/**
 * Trigger prescreen for a pitch deck document
 */
export const v2TriggerPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2TriggerPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupActivityQueryKey = (options) => createQueryKey('v2GetStartupActivity', options);
/**
 * Get startup activity log
 */
export const v2GetStartupActivityOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupActivityQueryKey(options)
});
export const v2ListTeamMembersQueryKey = (options) => createQueryKey('v2ListTeamMembers', options);
/**
 * List team members
 */
export const v2ListTeamMembersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListTeamMembersQueryKey(options)
});
/**
 * Create a team member
 */
export const v2CreateTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reorder team members
 */
export const v2ReorderTeamMembersMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ReorderTeamMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a team member
 */
export const v2DeleteTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update a team member
 */
export const v2UpdateTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Force re-scrape of a team member's LinkedIn profile
 */
export const v2RefreshTeamMemberLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RefreshTeamMemberLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove a startup member (owner only, cannot remove owners)
 */
export const v2RemoveStartupMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RemoveStartupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListStartupMatchesQueryKey = (options) => createQueryKey('v2ListStartupMatches', options);
/**
 * List recommended investors for a startup
 */
export const v2ListStartupMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupMatchesQueryKey(options)
});
/**
 * Request a custom-persona evaluation against the latest pitch
 *
 * Resolves the most recent COMPLETED pitch session for the startup and creates an investor evaluation request against it. Idempotent.
 */
export const v2RequestStartupMatchEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestStartupMatchEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record that the founder clicked through to an investor website
 *
 * Fire-and-forget: logs a Recombee CartAddition signal. Does not send any outbound communication.
 */
export const v2RecordStartupContactInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RecordStartupContactInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create a new investor entity
 */
export const v2CreateInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetInvestorProfileQueryKey = (options) => createQueryKey('v2GetInvestorProfile', options);
/**
 * Get investor profile
 */
export const v2GetInvestorProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorProfileQueryKey(options)
});
/**
 * Update investor profile
 */
export const v2UpdateInvestorProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateInvestorProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetInvestorPersonaQueryKey = (options) => createQueryKey('v2GetInvestorPersona', options);
/**
 * Get investor persona status and brief
 */
export const v2GetInvestorPersonaOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorPersona({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorPersonaQueryKey(options)
});
export const v2GetInvestorCreditBalanceQueryKey = (options) => createQueryKey('v2GetInvestorCreditBalance', options);
/**
 * Get investor credit balance
 */
export const v2GetInvestorCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorCreditBalanceQueryKey(options)
});
export const v2ListInvestorCreditsQueryKey = (options) => createQueryKey('v2ListInvestorCredits', options);
/**
 * List investor credit transactions
 */
export const v2ListInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorCreditsQueryKey(options)
});
export const v2GetInvestorFeedQueryKey = (options) => createQueryKey('v2GetInvestorFeed', options);
/**
 * Get investor pitch feed
 */
export const v2GetInvestorFeedOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorFeedQueryKey(options)
});
export const v2GetInvestorEvaluationQueryKey = (options) => createQueryKey('v2GetInvestorEvaluation', options);
/**
 * Get evaluation detail for investor
 */
export const v2GetInvestorEvaluationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorEvaluation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorEvaluationQueryKey(options)
});
export const v2GetInvestorJudgeProfileQueryKey = (options) => createQueryKey('v2GetInvestorJudgeProfile', options);
/**
 * Get judge profile for investor evaluation
 */
export const v2GetInvestorJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorJudgeProfileQueryKey(options)
});
/**
 * Send connection request to startup from evaluation
 */
export const v2InvestorConnectWithStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorConnectWithStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListInvestorEvaluationRequestsQueryKey = (options) => createQueryKey('v2ListInvestorEvaluationRequests', options);
/**
 * List all evaluation requests for investor
 */
export const v2ListInvestorEvaluationRequestsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorEvaluationRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorEvaluationRequestsQueryKey(options)
});
/**
 * Request personalized evaluation
 *
 * Request a personalized evaluation using the investor custom persona.
 */
export const v2RequestInvestorEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestInvestorEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Evaluate startup from investor perspective
 *
 * Triggers a custom evaluation for a startup. Uses the latest completed pitch session if available, otherwise falls back to prescreen using the pitch deck.
 */
export const v2EvaluateStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2EvaluateStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetMeQueryKey = (options) => createQueryKey('v2GetMe', options);
/**
 * Get current user's profile data
 */
export const v2GetMeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetMeQueryKey(options)
});
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 */
export const v2UpdateMeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetMyMembershipsQueryKey = (options) => createQueryKey('v2GetMyMemberships', options);
/**
 * Get all memberships (startups and investors) the current user belongs to
 */
export const v2GetMyMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetMyMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetMyMembershipsQueryKey(options)
});
export const v2ListStartupInvitesQueryKey = (options) => createQueryKey('v2ListStartupInvites', options);
/**
 * List pending invites for a startup
 */
export const v2ListStartupInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupInvitesQueryKey(options)
});
/**
 * Invite a user to a startup
 */
export const v2CreateStartupInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateStartupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Cancel a pending invite
 */
export const v2CancelStartupInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CancelStartupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListInvestorInvitesQueryKey = (options) => createQueryKey('v2ListInvestorInvites', options);
/**
 * List pending invites for an investor
 */
export const v2ListInvestorInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorInvitesQueryKey(options)
});
/**
 * Invite a user to an investor organization
 */
export const v2CreateInvestorInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateInvestorInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Cancel a pending investor invite
 */
export const v2CancelInvestorInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CancelInvestorInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2LookupInviteQueryKey = (options) => createQueryKey('v2LookupInvite', options);
/**
 * Look up invite details by token
 */
export const v2LookupInviteOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2LookupInvite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2LookupInviteQueryKey(options)
});
/**
 * Accept a team invite
 */
export const v2AcceptInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AcceptInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create pitch session
 */
export const v2CreatePitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreatePitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPitchQueryKey = (options) => createQueryKey('v2GetPitch', options);
/**
 * Get pitch session
 */
export const v2GetPitchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPitch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPitchQueryKey(options)
});
/**
 * Update pitch session
 */
export const v2UpdatePitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdatePitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Start pitch session
 */
export const v2StartPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StartPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Finish pitch session
 */
export const v2FinishPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2FinishPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get pitch video URL
 */
export const v2GetPitchVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GetPitchVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListShareLinksQueryKey = (options) => createQueryKey('v2ListShareLinks', options);
/**
 * List share links for a startup
 */
export const v2ListShareLinksOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListShareLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListShareLinksQueryKey(options)
});
/**
 * Create a new share link
 */
export const v2CreateShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a share link
 */
export const v2DeleteShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update a share link
 */
export const v2UpdateShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicProfilePreviewQueryKey = (options) => createQueryKey('v2GetPublicProfilePreview', options);
/**
 * Get public profile preview by share link token
 */
export const v2GetPublicProfilePreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicProfilePreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicProfilePreviewQueryKey(options)
});
/**
 * Register as a profile visitor with email
 */
export const v2RegisterProfileVisitorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RegisterProfileVisitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicProfileFullQueryKey = (options) => createQueryKey('v2GetPublicProfileFull', options);
/**
 * Get full public startup profile by share link token
 */
export const v2GetPublicProfileFullOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicProfileFull({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicProfileFullQueryKey(options)
});
/**
 * Send a heartbeat for profile viewing analytics
 */
export const v2ProfileHeartbeatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileHeartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Track a profile interaction event (click, document open/close)
 */
export const v2ProfileTrackEventMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileTrackEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Track multiple profile events in a single request (for page unload)
 */
export const v2ProfileTrackEventBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileTrackEventBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get a presigned download URL for a public profile document
 */
export const v2PublicDocumentDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PublicDocumentDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get a presigned URL for the pitch recording video
 */
export const v2PublicVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PublicVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Send a connection request message to the startup founder
 */
export const v2ContactFounderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ContactFounder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Submit or remove a thumbs up/down reaction on a statement
 */
export const v2SubmitStatementReactionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitStatementReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStatementReactionsQueryKey = (options) => createQueryKey('v2GetStatementReactions', options);
/**
 * Get all statement reactions for a visitor
 */
export const v2GetStatementReactionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStatementReactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStatementReactionsQueryKey(options)
});
/**
 * Submit agree/disagree feedback on selected text
 */
export const v2SubmitTextFeedbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitTextFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupAnalyticsQueryKey = (options) => createQueryKey('v2GetStartupAnalytics', options);
/**
 * Get anonymized founder analytics for a startup
 */
export const v2GetStartupAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupAnalyticsQueryKey(options)
});
export const v2GetInsightsReportQueryKey = (options) => createQueryKey('v2GetInsightsReport', options);
/**
 * Get the latest AI engagement report
 */
export const v2GetInsightsReportOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInsightsReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInsightsReportQueryKey(options)
});
/**
 * Generate AI-powered engagement report from investor behavior
 */
export const v2GenerateAnalyticsInsightsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GenerateAnalyticsInsights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicInvestorBySlugQueryKey = (options) => createQueryKey('v2GetPublicInvestorBySlug', options);
/**
 * Get public investor profile by slug
 */
export const v2GetPublicInvestorBySlugOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicInvestorBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicInvestorBySlugQueryKey(options)
});
export const v2GetWebsiteStatsQueryKey = (options) => createQueryKey('v2GetWebsiteStats', options);
/**
 * Get website stats
 *
 * Returns aggregate counts used on the marketing landing page
 */
export const v2GetWebsiteStatsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetWebsiteStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetWebsiteStatsQueryKey(options)
});
/**
 * Submit user feedback (general or evaluation)
 */
export const v2CreateFeedbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListUsersQueryKey = (options) => createQueryKey('v2AdminListUsers', options);
/**
 * List all users (admin)
 */
export const v2AdminListUsersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUsersQueryKey(options)
});
export const v2AdminListUsersInfiniteQueryKey = (options) => createQueryKey('v2AdminListUsers', options, true);
/**
 * List all users (admin)
 */
export const v2AdminListUsersInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUsersInfiniteQueryKey(options)
});
/**
 * Delete user and associated data (admin)
 */
export const v2AdminDeleteUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetUserByIdQueryKey = (options) => createQueryKey('v2AdminGetUserById', options);
/**
 * Get user by ID (admin)
 */
export const v2AdminGetUserByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserByIdQueryKey(options)
});
export const v2AdminGetUserMembershipsQueryKey = (options) => createQueryKey('v2AdminGetUserMemberships', options);
/**
 * Get user memberships (startups and investors)
 */
export const v2AdminGetUserMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserMembershipsQueryKey(options)
});
export const v2AdminGetUserDeletionPreviewQueryKey = (options) => createQueryKey('v2AdminGetUserDeletionPreview', options);
/**
 * Get user deletion preview (admin)
 */
export const v2AdminGetUserDeletionPreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserDeletionPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserDeletionPreviewQueryKey(options)
});
export const v2AdminListStartupsQueryKey = (options) => createQueryKey('v2AdminListStartups', options);
/**
 * List all startups (admin)
 */
export const v2AdminListStartupsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupsQueryKey(options)
});
export const v2AdminListStartupsInfiniteQueryKey = (options) => createQueryKey('v2AdminListStartups', options, true);
/**
 * List all startups (admin)
 */
export const v2AdminListStartupsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListStartups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupsInfiniteQueryKey(options)
});
export const v2AdminGetStartupByIdQueryKey = (options) => createQueryKey('v2AdminGetStartupById', options);
/**
 * Get startup by ID (admin)
 */
export const v2AdminGetStartupByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupByIdQueryKey(options)
});
export const v2AdminListStartupCreditsQueryKey = (options) => createQueryKey('v2AdminListStartupCredits', options);
/**
 * List startup credit transactions (admin)
 */
export const v2AdminListStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupCreditsQueryKey(options)
});
/**
 * Add credits to startup (admin)
 */
export const v2AdminAddStartupCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddStartupCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupSubscriptionQueryKey = (options) => createQueryKey('v2AdminGetStartupSubscription', options);
/**
 * Get subscription status for a startup (admin)
 */
export const v2AdminGetStartupSubscriptionOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupSubscription({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupSubscriptionQueryKey(options)
});
/**
 * Create or update subscription for a startup (admin)
 */
export const v2AdminUpsertStartupSubscriptionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpsertStartupSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record a one-off purchase for a startup (admin)
 */
export const v2AdminAddStartupPurchaseMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddStartupPurchase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupDocumentsQueryKey = (options) => createQueryKey('v2AdminGetStartupDocuments', options);
/**
 * Get documents for a startup (admin)
 */
export const v2AdminGetStartupDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupDocumentsQueryKey(options)
});
export const v2AdminGetStartupMembershipsQueryKey = (options) => createQueryKey('v2AdminGetStartupMemberships', options);
/**
 * Get startup memberships (admin)
 */
export const v2AdminGetStartupMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupMembershipsQueryKey(options)
});
export const v2AdminGetStartupTeamMembersQueryKey = (options) => createQueryKey('v2AdminGetStartupTeamMembers', options);
/**
 * Get startup team members (admin)
 */
export const v2AdminGetStartupTeamMembersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupTeamMembersQueryKey(options)
});
export const v2AdminListStartupMatchesQueryKey = (options) => createQueryKey('v2AdminListStartupMatches', options);
/**
 * List recommended investors for a startup (admin)
 */
export const v2AdminListStartupMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupMatchesQueryKey(options)
});
export const v2AdminGetStartupMatchesRefreshStatusQueryKey = (options) => createQueryKey('v2AdminGetStartupMatchesRefreshStatus', options);
/**
 * Get the latest matcher refresh request for a startup (admin)
 */
export const v2AdminGetStartupMatchesRefreshStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupMatchesRefreshStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupMatchesRefreshStatusQueryKey(options)
});
/**
 * Enqueue a matcher refresh for a startup (admin)
 *
 * Inserts a PENDING StartupMatchRefreshRequest. The engine scheduler picks it up and runs the matcher pipeline. Idempotent: if a request is already PENDING/PROCESSING, returns it.
 */
export const v2AdminRefreshStartupMatchesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRefreshStartupMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Schedule LinkedIn scrape for all team members missing raw data (admin)
 *
 * Finds team members with a LinkedIn URL but no rawLinkedInData (and not already SCRAPING) and triggers an async scrape for each. Returns immediately with the count of scheduled scrapes. Progress is visible via linkedinScrapeStatus on each member.
 */
export const v2AdminBackfillTeamMemberLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminBackfillTeamMemberLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorsQueryKey = (options) => createQueryKey('v2AdminListInvestors', options);
/**
 * List all investors (admin)
 */
export const v2AdminListInvestorsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorsQueryKey(options)
});
export const v2AdminListInvestorsInfiniteQueryKey = (options) => createQueryKey('v2AdminListInvestors', options, true);
/**
 * List all investors (admin)
 */
export const v2AdminListInvestorsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListInvestors({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorsInfiniteQueryKey(options)
});
export const v2AdminGetInvestorByIdQueryKey = (options) => createQueryKey('v2AdminGetInvestorById', options);
/**
 * Get investor by ID (admin)
 */
export const v2AdminGetInvestorByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorByIdQueryKey(options)
});
export const v2AdminGetInvestorPersonaQueryKey = (options) => createQueryKey('v2AdminGetInvestorPersona', options);
/**
 * Get investor persona with metric prompts (admin)
 */
export const v2AdminGetInvestorPersonaOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorPersona({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorPersonaQueryKey(options)
});
/**
 * Trigger persona research for investor (admin)
 */
export const v2AdminTriggerPersonaResearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminTriggerPersonaResearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorCreditsQueryKey = (options) => createQueryKey('v2AdminListInvestorCredits', options);
/**
 * List investor credit transactions (admin)
 */
export const v2AdminListInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorCreditsQueryKey(options)
});
/**
 * Add credits to investor (admin)
 */
export const v2AdminAddInvestorCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddInvestorCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetInvestorMembershipsQueryKey = (options) => createQueryKey('v2AdminGetInvestorMemberships', options);
/**
 * Get investor memberships (admin)
 */
export const v2AdminGetInvestorMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorMembershipsQueryKey(options)
});
export const v2AdminListEvaluationsQueryKey = (options) => createQueryKey('v2AdminListEvaluations', options);
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluationsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListEvaluationsQueryKey(options)
});
export const v2AdminListEvaluationsInfiniteQueryKey = (options) => createQueryKey('v2AdminListEvaluations', options, true);
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluationsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListEvaluations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListEvaluationsInfiniteQueryKey(options)
});
export const v2AdminGetEvaluationViewQueryKey = (options) => createQueryKey('v2AdminGetEvaluationView', options);
/**
 * Get evaluation in view format (same as founder detail)
 */
export const v2AdminGetEvaluationViewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetEvaluationView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetEvaluationViewQueryKey(options)
});
export const v2AdminGetEvaluationDetailsQueryKey = (options) => createQueryKey('v2AdminGetEvaluationDetails', options);
/**
 * Get single evaluation raw details with research data
 */
export const v2AdminGetEvaluationDetailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetEvaluationDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetEvaluationDetailsQueryKey(options)
});
export const v2AdminGetJudgeProfileQueryKey = (options) => createQueryKey('v2AdminGetJudgeProfile', options);
/**
 * Get judge profile for an evaluation (admin)
 */
export const v2AdminGetJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetJudgeProfileQueryKey(options)
});
/**
 * Regenerate evaluation for a pitch session (admin)
 */
export const v2AdminRegenerateEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Rerun prescreen with a selected document (admin)
 */
export const v2AdminRerunPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRerunPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const v2AdminDeletePrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeletePrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const v2AdminDeletePitchSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeletePitchSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a single evaluation (admin)
 */
export const v2AdminDeleteEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListDataRoomsQueryKey = (options) => createQueryKey('v2AdminListDataRooms', options);
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRoomsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListDataRooms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListDataRoomsQueryKey(options)
});
export const v2AdminListDataRoomsInfiniteQueryKey = (options) => createQueryKey('v2AdminListDataRooms', options, true);
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRoomsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListDataRooms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListDataRoomsInfiniteQueryKey(options)
});
export const v2AdminGetDataRoomByIdQueryKey = (options) => createQueryKey('v2AdminGetDataRoomById', options);
/**
 * Get data room by ID with content (admin)
 */
export const v2AdminGetDataRoomByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetDataRoomById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetDataRoomByIdQueryKey(options)
});
export const v2AdminGetDataRoomAnalyticsQueryKey = (options) => createQueryKey('v2AdminGetDataRoomAnalytics', options);
/**
 * Get data room analytics (admin)
 */
export const v2AdminGetDataRoomAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetDataRoomAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetDataRoomAnalyticsQueryKey(options)
});
export const v2AdminListAiInsightReportsQueryKey = (options) => createQueryKey('v2AdminListAiInsightReports', options);
/**
 * List latest AI insight reports per startup (admin)
 */
export const v2AdminListAiInsightReportsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListAiInsightReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAiInsightReportsQueryKey(options)
});
/**
 * Manually regenerate the AI insight report for a startup (admin)
 */
export const v2AdminRegenerateAiInsightReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateAiInsightReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupTextFeedbacksQueryKey = (options) => createQueryKey('v2AdminListStartupTextFeedbacks', options);
/**
 * List text highlight feedbacks for a startup
 */
export const v2AdminListStartupTextFeedbacksOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupTextFeedbacks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupTextFeedbacksQueryKey(options)
});
export const v2AdminListStartupReactionsQueryKey = (options) => createQueryKey('v2AdminListStartupReactions', options);
/**
 * List statement reactions (agree/disagree) for a startup
 */
export const v2AdminListStartupReactionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupReactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupReactionsQueryKey(options)
});
export const v2AdminListFeedbackQueryKey = (options) => createQueryKey('v2AdminListFeedback', options);
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedbackOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListFeedbackQueryKey(options)
});
export const v2AdminListFeedbackInfiniteQueryKey = (options) => createQueryKey('v2AdminListFeedback', options, true);
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedbackInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListFeedback({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListFeedbackInfiniteQueryKey(options)
});
export const v2AdminListAutomatedEmailsQueryKey = (options) => createQueryKey('v2AdminListAutomatedEmails', options);
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListAutomatedEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAutomatedEmailsQueryKey(options)
});
export const v2AdminListAutomatedEmailsInfiniteQueryKey = (options) => createQueryKey('v2AdminListAutomatedEmails', options, true);
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmailsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListAutomatedEmails({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAutomatedEmailsInfiniteQueryKey(options)
});
export const v2AdminGetAutomatedEmailByIdQueryKey = (options) => createQueryKey('v2AdminGetAutomatedEmailById', options);
/**
 * Get automated email by ID (admin)
 */
export const v2AdminGetAutomatedEmailByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetAutomatedEmailById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetAutomatedEmailByIdQueryKey(options)
});
export const v2AdminListBlogPostsQueryKey = (options) => createQueryKey('v2AdminListBlogPosts', options);
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPostsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListBlogPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListBlogPostsQueryKey(options)
});
export const v2AdminListBlogPostsInfiniteQueryKey = (options) => createQueryKey('v2AdminListBlogPosts', options, true);
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPostsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListBlogPosts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListBlogPostsInfiniteQueryKey(options)
});
/**
 * Create a new blog post
 */
export const v2AdminCreateBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminCreateBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a blog post
 */
export const v2AdminDeleteBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetBlogPostQueryKey = (options) => createQueryKey('v2AdminGetBlogPost', options);
/**
 * Get blog post by ID (admin)
 */
export const v2AdminGetBlogPostOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetBlogPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetBlogPostQueryKey(options)
});
/**
 * Update a blog post
 */
export const v2AdminUpdateBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListPublishedBlogPostsQueryKey = (options) => createQueryKey('v2ListPublishedBlogPosts', options);
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPostsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListPublishedBlogPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListPublishedBlogPostsQueryKey(options)
});
export const v2ListPublishedBlogPostsInfiniteQueryKey = (options) => createQueryKey('v2ListPublishedBlogPosts', options, true);
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPostsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2ListPublishedBlogPosts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListPublishedBlogPostsInfiniteQueryKey(options)
});
export const v2GetPublishedBlogPostQueryKey = (options) => createQueryKey('v2GetPublishedBlogPost', options);
/**
 * Get a published blog post by slug
 */
export const v2GetPublishedBlogPostOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublishedBlogPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublishedBlogPostQueryKey(options)
});
export const v2GetSubscriptionStatusQueryKey = (options) => createQueryKey('v2GetSubscriptionStatus', options);
/**
 * Get current subscription status and usage
 */
export const v2GetSubscriptionStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetSubscriptionStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetSubscriptionStatusQueryKey(options)
});
/**
 * Create Stripe Checkout session for subscription
 */
export const v2CreateSubscriptionCheckoutMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateSubscriptionCheckout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create Stripe Customer Portal session
 */
export const v2CreateSubscriptionPortalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateSubscriptionPortal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Purchase one-off session or evaluation
 */
export const v2PurchaseOneOffMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PurchaseOneOff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Handle Stripe webhook events
 */
export const v2StripeWebhookMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StripeWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
